import { useContext } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { AuthContext } from '../../Guard/AuthContext';
import { session } from '../../helpers/helpers';
import Button from '../Button/Button';
import { ContactStoresSelect } from './ContactStoresSelect';

const Header = () => {
  const { user } = useContext(AuthContext);
  const { push } = useHistory();

  // useEffect(() => {
  //   instanceFetch
  //     .get(ROUTES.LOCATIONS, null, token)
  //     .then((response) => setShopName(response.Name))
  //     .catch((error) => console.log(error));
  //   // instanceFetch.get(ROUTES.BALANCE, null, token).then((res) => !isEmpty(res) && setShopName(res[0].name)).catch((error) => {console.log(error)});
  // }, []);

  // Logout moved to Sidebar - keep header lean on mobile

  const handleLogout = () => {
    session.remove('token');
    push('/signin');
  };

  return (
    <header className="header">
      <div className="header-left-side">
        <button
          type="button"
          className="header__burger show-mobile"
          aria-label="Open menu"
          onClick={() => {
            try {
              window.dispatchEvent(new CustomEvent('toggleSidebar'));
            } catch (e) {
              // fallback: use a resize event
              window.dispatchEvent(new Event('resize'));
            }
          }}
        >
          <span className="header__burger-lines" />
        </button>

        <div className="show-desktop">
          <ContactStoresSelect />
        </div>
      </div>
      {/* center area for mobile: show selector in header on small screens */}
      <div className="header-center show-mobile">
        <ContactStoresSelect />
      </div>
      <div className="header-right-side">
        <NavLink to="/profile" className="header-user">
          <>
            <img className="header-user__avatar" src="/images/avatar.png" alt="avatar" />
            <div className="text-black-normal-f16-l28">{user?.email}</div>
          </>
        </NavLink>
      </div>
    </header>
  );
};

export default Header;
